import { HycProduct, IgcProduct } from '@/creditflowresearch/domain/Product';
import { ProductIdByAbbreviation } from '@/creditflowresearch/domain/Product/constants';
import { CorpSegment, FigSegment, SsaSegment } from '@/creditflowresearch/domain/Segment';
import { EuropeanMarket, UsMarket } from '@/creditflowresearch/domain/Market';
import { MarketIdByAbbreviation } from '@/creditflowresearch/domain/Market/constants';
import { MarketAbbreviations } from '@/creditflowresearch/domain/Market/types/MarketType';
import {
  isSsaDefaultedForProducts,
} from '@/creditflowresearch/domain/Segment/selectors/selectSegmentVisibility';
import URL from '@/creditflowresearch/Router/urlConstants';
import { parseQueryParamValue } from '@/creditflowresearch/ui/common/utils/query/parseQueryParams';

const PRODUCT_ID_BY_ABBREVIATION: Record<string, string> = ProductIdByAbbreviation;
const MARKET_ID_BY_ABBREVIATION: Record<string, string> = MarketIdByAbbreviation;

const toIds = (
  value: string | string[] | undefined,
  idByAbbreviation: Record<string, string>,
): string[] => parseQueryParamValue(value)
  .map((abbreviation) => idByAbbreviation[abbreviation])
  .filter(Boolean);

export const getDefaultCorporateSegments = (
  product: string | string[],
  market?: string | string[],
): string => (
  isSsaDefaultedForProducts(
    toIds(product, PRODUCT_ID_BY_ABBREVIATION),
    toIds(market, MARKET_ID_BY_ABBREVIATION),
  )
    ? [CorpSegment.TYPE, FigSegment.TYPE, SsaSegment.TYPE].toString()
    : [CorpSegment.TYPE, FigSegment.TYPE].toString()
);

export const getCorporatePageProductId = (url: string): string =>
  (url === URL.MARKET_OVERVIEW_HYC ? HycProduct.PRODUCT_ID : IgcProduct.PRODUCT_ID);

export const getCorporatePageDefaultParams = (url: string, granted: boolean = false): Record<string, string> => {
  const products = url === URL.MARKET_OVERVIEW_HYC ? HycProduct.ABBREVIATION : IgcProduct.ABBREVIATION;
  // TODO: remove when the European market opening period ends; the default reverts to UsMarket
  const markets: MarketAbbreviations = granted ? EuropeanMarket.ABBREVIATION : UsMarket.ABBREVIATION;

  return {
    markets,
    products,
    segments: getDefaultCorporateSegments(products, markets),
  };
};
